
import { useEffect, useState } from 'react';
import './App.css';
import html2canvas from 'html2canvas';
import data from './data';



function App() {

  const [isActionButtonDisabled, setIsActionButtonDisabled] = useState(true);
  const [result,setResult] = useState(null);
  const [search,setSearch] = useState('');

  const handleDownloadImage = async () => {
    const element = document.getElementById('card'),
    canvas = await html2canvas(element),
    data = canvas.toDataURL('image/jpg'),
    link = document.createElement('a');
  
    link.href = data;
    link.download = 'مقر اللجنة.jpg';
  
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(()=>{
    if(search.trim() !== ''){
      setIsActionButtonDisabled(false);
    } else {
      setIsActionButtonDisabled(true);
    }
  },[search]);

  function convertArabicToEnglish(str) {
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    
    for (let i = 0; i < 10; i++) {
        str = str.replace(arabicNumbers[i], i);
    }
    
    return str;
}

  const handleClickSearch = () => {
    const number = convertArabicToEnglish(search);
    const finalResult = data?.filter(e=>e._id === number);
    if(finalResult && Array.isArray(finalResult) && finalResult?.length > 0) {
      setResult(finalResult[0]);
    } else {
      setResult('none');
    }
  }

  const handleClickReset = () => {
    setSearch('');
    setResult(null);
  }



  return (
    <div className="App">
      <div className="page">
        <header>
          <img src="/lagnty.jpg" alt="" style={{maxWidth: '150px'}} />
          {/* <div className='container-fluid g-0'>
            <div className='row g-0'>
              <div className='col-3 text-center no-padding' style={{alignSelf:'center'}}><img src="/ministry.jpg" alt="شعار مدرسة عدي بن حاتم المتوسطة" className='logo2' /></div>
              <div className='col-6 text-center'>
                <p>المملكة العربية السعودية
                  <br />
                  وزارة التعليم
                  <br />
                  ادارة تعليم محافظة جدة
                </p>
              </div>
              <div className='col-3 text-center no-padding' style={{alignSelf:'center'}}><img src="/logo.jpg" alt="شعار وزارة التعليم السعودية" className='logo' /></div>
            </div>
          </div> */}
        </header>
        <section>
          <div className='text-center'>
            <h1 className='school_name'>دليلك لمقعد الاختبار</h1>
            <p className='form_head'><span>اهلا بك عزيزي الطالب</span>
            فضلا ادخل رقم هويتك للاستعلام عن مقر لجنتك</p>
          </div>
          <div className=''>
          <div className="input-group mb-3">
            <input type="text" className="form-control" placeholder="رقم الهوية" aria-label="رقم الهوية" aria-describedby="basic-addon2" value={search} onChange={e=>setSearch(e?.target?.value && (/^[0-9\b]+$/.test(e?.target?.value) || /[\u0660-\u0669]/.test(e?.target?.value)) ? e?.target?.value : '')} />
            <div className="input-group-append">
              <button className="btn btn-primary" disabled={isActionButtonDisabled} type="button" onClick={()=>handleClickSearch()}>بحث</button>
            </div>
          </div>
          </div>
          {result ? result === 'none' ?
          <div className='result none'>
            <div className='text-center'>
              من فضلك تأكد من رقم الهوية.
            </div>
          </div>
          : <>
          <div className='result' id="card"><div className='water-mark'></div>
            <div><strong>اسم المدرسة: </strong>{result?.school}</div>
            <div><strong>رقم الهوية: </strong>{result?._id}</div>
            <div><strong>الاسم: </strong>{result?.name}</div>
            <div><strong>الصف: </strong>{result?.class}</div>
            <div><strong>رقم اللجنة: </strong>{result?.room}</div>
            <div><strong>مقر اللجنة: </strong>{result?.location}</div>
            {result?.number ? <div><strong>رقم الجلوس: </strong>{result?.number}</div> : ''}
            {result?.date ? <div><strong>التاريخ: </strong>{result?.date}</div> : ''}
          </div>
          <div className='download' onClick={()=>handleDownloadImage()}>
<svg width="21px" height="21px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M3 14.25C3.41421 14.25 3.75 14.5858 3.75 15C3.75 16.4354 3.75159 17.4365 3.85315 18.1919C3.9518 18.9257 4.13225 19.3142 4.40901 19.591C4.68577 19.8678 5.07435 20.0482 5.80812 20.1469C6.56347 20.2484 7.56459 20.25 9 20.25H15C16.4354 20.25 17.4365 20.2484 18.1919 20.1469C18.9257 20.0482 19.3142 19.8678 19.591 19.591C19.8678 19.3142 20.0482 18.9257 20.1469 18.1919C20.2484 17.4365 20.25 16.4354 20.25 15C20.25 14.5858 20.5858 14.25 21 14.25C21.4142 14.25 21.75 14.5858 21.75 15V15.0549C21.75 16.4225 21.75 17.5248 21.6335 18.3918C21.5125 19.2919 21.2536 20.0497 20.6517 20.6516C20.0497 21.2536 19.2919 21.5125 18.3918 21.6335C17.5248 21.75 16.4225 21.75 15.0549 21.75H8.94513C7.57754 21.75 6.47522 21.75 5.60825 21.6335C4.70814 21.5125 3.95027 21.2536 3.34835 20.6517C2.74643 20.0497 2.48754 19.2919 2.36652 18.3918C2.24996 17.5248 2.24998 16.4225 2.25 15.0549C2.25 15.0366 2.25 15.0183 2.25 15C2.25 14.5858 2.58579 14.25 3 14.25Z" fill="#ffffff"/>
<path fillRule="evenodd" clipRule="evenodd" d="M12 16.75C12.2106 16.75 12.4114 16.6615 12.5535 16.5061L16.5535 12.1311C16.833 11.8254 16.8118 11.351 16.5061 11.0715C16.2004 10.792 15.726 10.8132 15.4465 11.1189L12.75 14.0682V3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V14.0682L8.55353 11.1189C8.27403 10.8132 7.79963 10.792 7.49393 11.0715C7.18823 11.351 7.16698 11.8254 7.44648 12.1311L11.4465 16.5061C11.5886 16.6615 11.7894 16.75 12 16.75Z" fill="#ffffff"/>
</svg>
 تحميل</div>
 <div className='download reset' onClick={()=>handleClickReset()}>
            عودة
 </div>
 </> : ''}
        </section>
        <footer></footer>
      </div>
    </div>
  );
}

export default App;
